export const PRICE = '23 EUR'

export const BRAND = 'Lash & Brow Instructor Ready™'

/** Carosello — pagine reali del Volume 2, in questo ordine esatto. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nNFJ8fz3Z9KkkiqCqUjUox/01_pagina_13.webp',
    caption: 'Errore frequente nel mapping — Pagina 13',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eKUYPiRzEsrMLHa1W4hf8Y/02_pagina_21.webp',
    caption: 'Tonalità, intensità, risultato — Pagina 21',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mSBcb6xLYPkr4F3FpQB3HG/03_pagina_42.webp',
    caption: 'Rimozione conservativa — Pagina 42',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cLhpxXNXiGfUxzSAqagHBe/04_pagina_45.webp',
    caption: 'Cosa cambia con la laminazione — Pagina 45',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eLgJKK8vFpm2r1hJqjDRNi/05_pagina_36.webp',
    caption: 'Rubrica di valutazione — Pagina 36',
  },
]

/** Sezione problema — tre blocchi. */
export const painPoints = [
  { title: 'Troppe ore di preparazione', text: 'Lezioni e materiali da creare continuamente.' },
  { title: 'Esercizi da inventare', text: 'Attività pratiche e schede da organizzare per ogni corso.' },
  { title: 'Valutazioni poco strutturate', text: 'Difficoltà nel seguire i progressi delle allieve.' },
]

/** Sezione soluzione — cosa puoi fare con il sistema. */
export const solutionPoints = [
  'Preparare le lezioni partendo da strutture già organizzate.',
  'Utilizzare esercizi e attività pratiche per le allieve.',
  'Insegnare tecniche di ciglia e sopracciglia con un percorso chiaro.',
  'Monitorare i progressi attraverso strumenti di valutazione.',
  "Dedicare più attenzione all'insegnamento e meno alla preparazione.",
]

/** I sei volumi. I colori riprendono le copertine del mockup. */
export const volumes = [
  {
    number: 1,
    title: "Fondamenti per l'insegnamento Lash & Brow",
    description: 'Fondamenti didattici, organizzazione delle lezioni, sicurezza e metodologia per formatrici.',
    accent: '#F9E4DF',
  },
  {
    number: 2,
    title: 'Tecniche professionali per le sopracciglia',
    description: 'Brow mapping, simmetria, shaping, colorazione, henné e laminazione.',
    accent: '#F5D2CD',
  },
  {
    number: 3,
    title: 'Tecniche professionali per le ciglia',
    description: 'Extension ciglia, lash mapping, tecniche professionali, lash lift e cura successiva.',
    accent: '#D6E5F4',
  },
  {
    number: 4,
    title: 'Libreria di lezioni pronte da insegnare',
    description: 'Lezioni strutturate, dimostrazioni guidate e attività per la classe.',
    accent: '#D3EAD9',
  },
  {
    number: 5,
    title: 'Workbook di pratica per le allieve',
    description: 'Esercizi, schede di mapping e attività per sviluppare le competenze.',
    accent: '#E4D7F2',
  },
  {
    number: 6,
    title: 'Strumenti di valutazione e certificazione',
    description: 'Rubriche, verifiche e strumenti per documentare il percorso formativo.',
    accent: '#F6E2C3',
  },
]

export const volumeFlow = ['Fondamenti', 'Sopracciglia', 'Ciglia', 'Lezioni', 'Pratica', 'Valutazione']

/** Risorse visive presenti nei materiali. */
export const visualResources = [
  'Schemi di brow mapping',
  'Confronti prima e dopo',
  'Errori frequenti spiegati',
  'Scale di tonalità e intensità',
  'Sequenze tecniche guidate',
  'Rubriche di valutazione',
  'Schede di pratica',
  'Indicazioni post-trattamento',
]

/** I cinque bonus. */
export const bonuses = [
  {
    number: 'Bonus 1',
    title: 'Atlante visivo Lash & Brow',
    description: 'Riferimenti visivi e attività per spiegare meglio le tecniche.',
    accent: '#F5D2CD',
  },
  {
    number: 'Bonus 2',
    title: 'Moduli cliente e guide post-trattamento',
    description: 'Schede di consulenza, moduli e indicazioni per la cura successiva.',
    accent: '#D3EAD9',
  },
  {
    number: 'Bonus 3',
    title: 'Raccolta di casi pratici avanzati',
    description: 'Situazioni da analizzare e utilizzare durante la formazione.',
    accent: '#D6E5F4',
  },
  {
    number: 'Bonus 4',
    title: 'Manuale per le allieve',
    description: "Materiale di orientamento e consultazione per accompagnare l'apprendimento.",
    accent: '#E4D7F2',
  },
  {
    number: 'Bonus 5',
    title: 'Raccolta di presentazioni didattiche',
    description: 'Contenuti organizzati per supportare le spiegazioni in classe.',
    accent: '#F6E2C3',
  },
]

/** Prima e dopo. */
export const withoutSystem = [
  'Cercare materiale prima di ogni lezione',
  'Creare spiegazioni da zero',
  'Inventare esercizi e attività pratiche',
  'Preparare valutazioni improvvisate',
  'Organizzare tutto da sola',
]

export const withSystem = [
  "Scegli l'argomento",
  'Apri il volume giusto',
  'Usa lezioni già strutturate',
  'Assegna esercizi alle allieve',
  'Valuta i progressi con le rubriche',
]

/** Sezione benefici. */
export const benefits = [
  { title: 'Risparmia tempo', text: 'Parti da lezioni e risorse già strutturate.' },
  { title: 'Insegna con più metodo', text: 'Segui una progressione didattica chiara.' },
  { title: 'Coinvolgi le allieve', text: 'Utilizza esercizi, schede e attività pratiche.' },
  { title: 'Valuta i progressi', text: 'Affidati a rubriche e strumenti di verifica.' },
]

/** A chi è rivolto. */
export const audience = [
  'Formatrici di extension ciglia',
  'Insegnanti di tecniche sopracciglia',
  'Lash artist che vogliono insegnare',
  'Brow artist che vogliono insegnare',
  'Titolari di accademie beauty',
  'Centri di formazione beauty',
]

/** Offerta — riepilogo. */
export const offerIncludes = [
  '6 volumi digitali',
  '5 bonus didattici',
  'Contenuti in italiano',
  'Materiali PDF',
  'Pagamento unico',
]

export const faqs = [
  {
    question: 'È un prodotto fisico?',
    answer: 'No. È una raccolta di materiali digitali in formato PDF.',
  },
  {
    question: 'Il materiale è in italiano?',
    answer: 'Sì, il sistema è disponibile nella Versione Italiana.',
  },
  {
    question: 'È adatto a chi insegna già?',
    answer: 'Sì. È pensato per aiutare le formatrici a organizzare lezioni, esercizi e valutazioni.',
  },
  {
    question: 'Posso utilizzarlo se voglio iniziare a insegnare?',
    answer:
      'Sì. Include fondamenti didattici e materiali utili per strutturare un percorso formativo. Non sostituisce le qualifiche professionali eventualmente richieste.',
  },
  {
    question: 'Include materiali per le allieve?',
    answer: 'Sì. Sono presenti esercizi, workbook e risorse didattiche.',
  },
  {
    question: 'Riceverò tutti i volumi e i bonus?',
    answer: "Sì. L'offerta comprende i 6 volumi e i 5 bonus descritti.",
  },
  {
    question: 'Il pagamento è sicuro?',
    answer: 'Sì. Il checkout è sicuro e crittografato, e il pagamento viene elaborato nella tua valuta locale.',
  },
]
